export const supportLinks = [
  { linkName: "Privacy policies", path: "/privacy-policies" },
  // { linkName: "FAQs", path: "/frequently-asked-questions" },
  { linkName: "Terms & Conditions", path: "/terms-and-conditions" },
];
